import React from "react";
import { Play, Sparkle, Warning } from "@phosphor-icons/react";
import { studioCast, studioHealth, gradeLabel } from "../../lib/studioHealth";

function Portrait({ spr, label, missing, onClick, active }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={"gc-cast-slot " + (active ? "is-on" : "") + (missing ? " is-miss" : "")}
      title={label}
    >
      <span className="gc-cast-frame">
        {spr?.data_url ? (
          <img src={spr.data_url} alt="" style={{ imageRendering: "pixelated" }} />
        ) : (
          <span className="gc-cast-empty">?</span>
        )}
      </span>
      <span className="gc-cast-role">{label}</span>
    </button>
  );
}

export default function StudioRail({ project, tab, onJump, onRun, onAi, focus }) {
  const cast = studioCast(project);
  const health = studioHealth(project);
  const grade = gradeLabel(health.overall);
  const next = health.next[0];
  const missSfx = !cast.sfx.jump || !cast.sfx.hit || !cast.sfx.pickup;

  return (
    <div className="gc-cast" data-testid="studio-rail">
      <button type="button" className="gc-cast-grade" onClick={() => onJump("overview")} title="Salud del estudio">
        <b>{grade.letter}</b>
        <span>{health.overall}%</span>
      </button>

      <div className="gc-cast-row">
        {cast.members.map((m) => (
          <Portrait
            key={m.kind}
            spr={m.spr}
            label={m.ent?.name || m.role}
            missing={!m.ent || !m.spr}
            active={focus?.entityId === m.ent?.id || focus?.spriteId === m.spr?.id}
            onClick={() => {
              if (m.ent) onJump("ideas", { entityId: m.ent.id, spriteId: m.spr?.id, tab: "ideas" });
              else onJump(m.tab);
            }}
          />
        ))}
      </div>

      <div className="gc-cast-sfx" title="SFX del loop">
        {[
          ["jump", "Salto", cast.sfx.jump],
          ["hit", "Golpe", cast.sfx.hit],
          ["pickup", "Pickup", cast.sfx.pickup],
        ].map(([id, lab, ok]) => (
          <button
            key={id}
            type="button"
            className={"gc-cast-pip " + (ok ? "ok" : "")}
            onClick={() => onJump("audio")}
          >
            {ok ? "●" : "○"} {lab}
          </button>
        ))}
      </div>

      <div className="gc-cast-next min-w-0">
        {next && (
          <button type="button" className="gc-cast-action" onClick={() => onJump(next.tab)}>
            {missSfx && tab !== "audio" ? <Warning size={12} className="text-amber-400 shrink-0" /> : null}
            <span className="truncate">{next.label}</span>
          </button>
        )}
      </div>

      <div className="gc-cast-tools">
        {onAi && (
          <button type="button" className="gc-btn gc-btn-ghost h-9 w-9 p-0 md:hidden" onClick={onAi} aria-label="IA">
            <Sparkle size={16} weight="fill" className="text-sky-500" />
          </button>
        )}
        <button
          type="button"
          className="gc-btn gc-btn-primary h-9 px-3 hidden md:inline-flex"
          onClick={onRun}
        >
          <Play size={14} weight="fill" /> Run
        </button>
      </div>
    </div>
  );
}
